import { gql, useQuery } from '@apollo/react-hooks';
import type {
  FrcAssessment,
  GetFrcAssessment,
  FrcFilterType,
  DrcAdmissionInfo,
} from './types';
import { FrcsbDecision } from '../../FRCAssessment';

const GET_FRCSB_ASSESSMENT = gql`
  query ($input: AssessmentFilter!) {
    frcsbAssessment(input: $input) {
      approveDsrcChairInTeam
      approveWaivingEntranceRequirements
      remarks
    }
    dsrcAdmission(filter: $input) {
      entranceRequirementWaive
      confirmationChairInTeam
    }
    hodDosAssessment(input: $input) {
      externalGrantOrDEA {
        required
        confirmation
        accountCode
      }
      nonSTEMOrNonSHS {
        required
        confirmation
        assumptionDate
      }
      decision
    }
  }
`;

export const useGetFrcAssessment = (
  filter: FrcFilterType,
): GetFrcAssessment => {
  const { data, loading, error, refetch } = useQuery(GET_FRCSB_ASSESSMENT, {
    variables: { input: filter },
    fetchPolicy: 'network-only',
  });

  const frcAssessment: FrcAssessment = {
    approveDsrcChairInTeam:
      data?.frcsbAssessment?.approveDsrcChairInTeam ?? FrcsbDecision.NA,
    approveWaivingEntranceRequirements:
      data?.frcsbAssessment?.approveWaivingEntranceRequirements ??
      FrcsbDecision.NA,
    remarks: data?.frcsbAssessment?.remarks ?? '',
  };

  const drcAdmissionInfo: DrcAdmissionInfo = {
    entranceRequirementWaive:
      data?.dsrcAdmission?.entranceRequirementWaive ?? false,
    confirmationChairInTeam:
      data?.dsrcAdmission?.confirmationChairInTeam ?? false,
  };

  return { frcAssessment, drcAdmissionInfo, loading, error, refetch };
};
